import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { ServiceIcon } from "@/lib/serviceIcons";

export function ServicesRow() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/settings/services").then((r) => setData(r.data)).catch(() => {}); }, []);
  const items = data?.items || [];
  if (!items.length) return null;

  return (
    <section data-testid="services-row" className="max-w-7xl mx-auto px-6 lg:px-8 -mt-10 lg:-mt-14 pb-20 lg:pb-24">
      <div className="eyebrow mb-6">Event services</div>
      <div className="flex gap-5 sm:gap-6 lg:gap-10 overflow-x-auto sm:overflow-visible snap-x snap-mandatory pb-3 sm:pb-0 -mx-6 px-6 sm:mx-0 sm:px-0 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
        {items.map((s) => (
          <Link
            key={s.id}
            to={`/services/${s.id}`}
            data-testid={`service-card-${s.id}`}
            className="group snap-start shrink-0 w-[108px] sm:w-auto sm:flex-1 flex flex-col items-center gap-3 text-center"
          >
            <div className="w-[76px] h-[76px] lg:w-[88px] lg:h-[88px] rounded-full border border-[#d4af37]/70 bg-[#fdfbf7] text-[#b8912a] flex items-center justify-center overflow-hidden transition-all duration-300 group-hover:bg-[#d4af37] group-hover:text-[#292724] group-hover:shadow-[0_12px_30px_-10px_rgba(212,175,55,0.6)] group-hover:-translate-y-1">
              {s.image_url
                ? <img src={s.image_url} alt={s.name} className="w-full h-full object-cover object-center" loading="lazy" />
                : <ServiceIcon name={s.icon} className="w-7 h-7 lg:w-8 lg:h-8" />}
            </div>
            <div className="text-[11px] sm:text-xs tracking-[0.12em] uppercase text-[#5a544c] group-hover:text-[#292724] leading-snug">{s.name}</div>
          </Link>
        ))}
      </div>
    </section>
  );
}
